export enum AttributeSystemEntity {
Employee,
EmployeeContract,
BusinessEntity,
Department,
}
